@if (isUserMessage()) {
  <div class="chat-message chat-message--user">
    <div class="chat-message__avatar">
      <coin-employee-picture
        size="small"
        [gid]="gid()" />
    </div>
    <div class="chat-message__message">
      <markdown [data]="message().content"></markdown>
    </div>
  </div>
  <div class="chat-message__toolbar">
    <coin-message-toolbar [actions]="messageActions(message().content)()"></coin-message-toolbar>
  </div>
} @else {
  <div class="chat-message">
    <div
      class="chat-message__avatar"
      [class.chat-message__avatar--coco]="!botAvatarIsPng()">
      <img
        alt="Coin chat bot avatar"
        aria-hidden="true"
        [src]="botAvatarPath()" />
    </div>
    <div class="chat-message__message">
      <markdown [data]="message().content"></markdown>
      @if (message().finished) {
        <div class="chat-message__toolbar">
          <coin-message-toolbar [actions]="messageActions(message().content)()"></coin-message-toolbar>

          @if (message().referenceDocuments.length > 0) {
            <coin-v2-button
              type="outline"
              text="Sources"
              (click)="toggleSources()" />
          }
        </div>
      }

      @if (sourcesOpen()) {
        @for (doc of message().referenceDocuments; track doc.documentId) {
          <coin-document-reference-card
            [document]="doc"
            (download)="download.emit($event)"></coin-document-reference-card>
        }
      }
    </div>
  </div>
}
